<template>
  <div class="ras-review">
    <div class="riw-callout-stack ras-review__gate">
      <!-- A refused save, inline (the server stays the authority) -->
      <div v-if="saveError" class="riw-callout riw-callout--err" role="alert">
        <v-icon class="riw-callout__icon">mdi-alert-circle-outline</v-icon>
        <div class="riw-callout__body">
          <span class="riw-callout__title">{{ saveError.title }}</span>{{ saveError.text }}
          <button
            v-if="saveError.goStep"
            type="button"
            class="ras-link"
            @click="$emit('go-step', saveError.goStep)">{{ saveError.goLabel }}</button>
        </div>
      </div>

      <div v-if="blockers.length" class="riw-callout riw-callout--err" role="alert">
        <v-icon class="riw-callout__icon">mdi-alert-circle-outline</v-icon>
        <div class="riw-callout__body">
          <span class="riw-callout__title">This source can’t be saved yet.</span>
          <ul class="ras-list">
            <li v-for="blocker in blockers" :key="blocker.key">
              <b>{{ blocker.title }}</b> {{ blocker.text }}
              <button type="button" class="ras-link" @click="$emit('go-step', blocker.goStep)">{{ blocker.goLabel }}</button>
            </li>
          </ul>
        </div>
      </div>
      <div v-else-if="registerUnset" class="riw-callout riw-callout--warn riw-callout--compact">
        <v-icon class="riw-callout__icon">mdi-lock-alert-outline</v-icon>
        <div class="riw-callout__body">
          <span class="riw-callout__title">Saved as Manual Only.</span>Pulls are refused until an administrator sets the register mode of {{ registerName || 'this register' }}.
        </div>
      </div>
      <div v-else-if="!saveError" class="riw-callout riw-callout--ok riw-callout--compact">
        <v-icon class="riw-callout__icon">mdi-check-circle-outline</v-icon>
        <div class="riw-callout__body"><span class="riw-callout__title">Ready to save.</span>{{ readyText }}</div>
      </div>
    </div>

    <section v-for="card in cards" :key="card.key" class="ras-card" :aria-labelledby="`${_uid}-${card.key}`">
      <div class="ras-card__head">
        <v-icon size="18">{{ card.icon }}</v-icon>
        <span :id="`${_uid}-${card.key}`" class="riw-label-text">{{ card.title }}</span>
        <v-btn small text class="ras-card__edit" :aria-label="`Edit ${card.title}`" @click="$emit('go-step', card.step)">
          <v-icon left small>mdi-pencil-outline</v-icon>Edit
        </v-btn>
      </div>
      <table class="ras-kv">
        <tbody>
          <tr v-for="row in card.rows" :key="row.label">
            <th scope="row">{{ row.label }}</th>
            <td :class="row.tone ? `is-${row.tone}` : ''">
              <span v-if="row.method" class="ras-method">{{ row.method }}</span>
              <span v-if="row.chip" class="ras-chip" :class="{ 'is-manual': row.manual }">
                <v-icon size="14">{{ row.manual ? 'mdi-hand-back-right' : 'mdi-calendar-clock' }}</v-icon>{{ row.value }}
              </span>
              <span v-else :class="{ 'riw-mono': row.mono }" :title="row.value">{{ row.value }}</span>
            </td>
          </tr>
        </tbody>
      </table>
    </section>
  </div>
</template>

<script>
  import { frequencyLabel, isScheduled } from '../../../modules/apiSourceRules';

  /**
   * Review step of the Register API data source wizard: the rules still broken (each linked to the
   * step that fixes it), a refused save shown inline, and the source summary cards.
   */
  export default {
    name: 'ApiReviewStep',
    props: {
      /** apiSourcePresentation.reviewCards(...) */
      cards: { type: Array, default: () => [] },
      /** apiSourceRules.saveBlockers(...) */
      blockers: { type: Array, default: () => [] },
      /** apiSourceRules.saveErrorPresentation(...) or null */
      saveError: { type: Object, default: null },
      registerUnset: { type: Boolean, default: false },
      registerName: { type: String, default: '' },
      schedule: { type: Object, required: true },
      hasIdentity: { type: Boolean, default: false },
      identityLabel: { type: String, default: '' },
    },
    computed: {
      readyText() {
        if (!this.hasIdentity) return 'Manual pulls add every row again — no identity column.';
        return isScheduled(this.schedule.frequency)
          ? `Each ${frequencyLabel(this.schedule.frequency).toLowerCase()} pull updates rows matched on ${this.identityLabel}.`
          : `Manual pulls update rows matched on ${this.identityLabel}.`;
      },
    },
  };
</script>
